import clsx from 'clsx';
import { useActiveBundle } from '@/context/active-bundle';
import { Copilot } from '@/features/copilot';
import { GlobalCopilotConfiguration } from '@/features/copilot/global-copilot-configuration';
import { useFeatureFlag, FeatureFlag, hasFeatureFlag } from '@/services/auth/feature-flags';
import { AppBundle } from '@/utils/app-bundles';
import { Box, PlumaProvider, useSideNavState } from '@customerio/pluma-components/react';
import { defaultTheme, newTheme, darkTheme } from '@customerio/pluma-components/css';
import { PersonDropdown } from '../top-navigation/components/person-dropdown';
import { SampleWorkspaceBadge } from '../top-navigation/components/sample-workspace';
import * as styles from './index.css';
import * as oldStyles from '../top-navigation/index.css';
import { NotificationsDropdown } from '../top-navigation/components/notifications-dropdown';
import { SupportChat, useSupportChat } from '@/features/support';
import { HelpButton } from '@/features/help-sidebar/help-button';
import { CommandDialogButton } from './components/command-dialog-button';
import { useThemeContext } from '@/context/theme';

export function TopNavigationNew(props: { isCollapsible?: boolean }) {
  const { isCollapsible = true } = props;

  const supportChat = useSupportChat();
  const activeApp = useActiveBundle();
  const sideNavState = useSideNavState();
  const themeContext = useThemeContext();

  const withNewTokens = useFeatureFlag(FeatureFlag.NavTokens2026);

  const resolvedTheme = themeContext.isDarkMode ? darkTheme : withNewTokens ? newTheme : defaultTheme;

  return (
    <PlumaProvider
      theme={resolvedTheme}
      className={clsx(
        styles.topNavigationNew,
        isCollapsible && sideNavState != null && sideNavState.isCollapsed === true
          ? styles.topNavigationNewCollapsed
          : null,
        hasFeatureFlag(FeatureFlag.UniversalSearchDialog) ? styles.topNavigationWithCommandDialogButton : null,
      )}
    >
      <Box display="flex" alignItems="center" justifyContent="flex-start">
        <Box display="flex" alignItems="center" gap="075">
          {Object.values(AppBundle).map((bundle) => (
            <div
              key={bundle}
              className={oldStyles.portal}
              id={`hydra-top-nav-portal-left-${bundle}`}
              style={{ ...(activeApp !== bundle ? { display: 'none' } : {}) }}
            ></div>
          ))}
        </Box>

        <SampleWorkspaceBadge isNewLayout={true} />
      </Box>

      {hasFeatureFlag(FeatureFlag.UniversalSearchDialog) ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CommandDialogButton />
        </Box>
      ) : null}

      <Box display="flex" alignItems="center" justifyContent="flex-end" gap="075">
        {Object.values(AppBundle).map((bundle) => (
          <div
            key={bundle}
            className={oldStyles.portal}
            id={`hydra-top-nav-portal-right-${bundle}`}
            style={{ ...(activeApp !== bundle ? { display: 'none' } : {}) }}
          ></div>
        ))}
        {/* Keep the button behind the flag for now */}
        <HelpButton isNewLayout={true} />
        <NotificationsDropdown isNewLayout={true} />
        {hasFeatureFlag(FeatureFlag.AiEnabled) ? (
          <>
            <Copilot isNewLayout={true} />
            <GlobalCopilotConfiguration />
          </>
        ) : supportChat.isHandoverAllowed ? (
          <SupportChat isNewLayout={true} />
        ) : null}
        <PersonDropdown isNewLayout={true} />
      </Box>
    </PlumaProvider>
  );
}
